import { useState } from 'react';
import { IUser } from '../../../authentication/contracts/IUser.interface';
// import profileImgUrl from '../../../shared/assets/images/default_profile_image.svg';


export default function useAuthenticationHook(): IUser {

  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [tenantId, setTenantId] = useState('');
  const [userName, setUserName] = useState('');
  const [avatarUrl, setAvatarUrl] = useState('');

  const logout = () => {
    login(false);
  }

  const login = (value: boolean) => {

    setIsAuthenticated(value);

    // props
    setTenantId(value ? tenantId : '');
    setUserName(value ? 'pradeep' : '');
    setAvatarUrl(value ? '' : '');
  }

  return {
    // status
    isAuthenticated, isNotAuthenticated: !isAuthenticated,
    // user props
    tenantId, userName, avatarUrl,

    // methods
    logout, login,
  } as IUser;
}